import CustomFileAttachment from 'Common/CustomFileAttachment/CustomFileAttachment';
import Show from 'Components/Show/Show';
import FileAttachmentViewer from 'Popups/FileAttachmentViewer/FileAttachmentViewer';
import React, { useState } from 'react'
import { LuChevronDown } from "react-icons/lu";
const PaymentAttatchments = ({ paymentAttatchment, handleAttachmentChange, handleRemoveAttachment }) => {
    const [showAttachments, setShowAttachments] = useState(false);
    const [viewAttachment, setViewAttachment] = useState({
        status: false,
        Attachment: 0,
        fileExtension: "",
    });
    const openViewAttachment = (item, itemIndex) => {
        const fileExtension = item.fileName.split('.').pop();
        setViewAttachment({
            status: true,
            Attachment: item.fileBase64,
            fileExtension: fileExtension,
        });
    }
    const closeViewAttachment = () => {
        setViewAttachment({
            status: false,
            Attachment: 0,
            fileExtension: "",
        });
    }
    return (
        <>
            {viewAttachment.status && (
                <FileAttachmentViewer
                    onClose={closeViewAttachment}
                    viewAttachment={viewAttachment}
                />
            )}
            <button onClick={() => setShowAttachments(!showAttachments)} className="flex items-center gap-2 text-sm text-slate-600 hover:text-slate-800"  >
                <LuChevronDown className={`w-4 h-4 transition-transform ${showAttachments ? 'rotate-180' : ''}`} />
                Attachments
            </button>
            <Show when={showAttachments}>
                {/* <div className="p-6 text-center border-2 border-dashed rounded-lg border-slate-300">
                    <input type="file" id="attachments" className="hidden" multiple onChange={handlePaymentAttatchments} />
                    <label htmlFor="attachments" className="text-sm cursor-pointer text-slate-600 hover:text-slate-800"  >
                        Click to upload or drag and drop
                    </label>
                </div> */}
                <CustomFileAttachment
                    multiple={true}
                    onFileChange={handleAttachmentChange}
                    name="paymentAttachment"
                    onDeleteFile={handleRemoveAttachment}
                    data={paymentAttatchment}
                    openViewAttachment={openViewAttachment}
                />
            </Show>
        </>
    )
}

export default PaymentAttatchments